<template>
  <AppLink class="text-link" :link="link">
    <i v-if="icon" class="icon text-link__icon" :class="icon"></i>
    <span class="text-link__content"><slot /></span>
  </AppLink>
</template>

<script>
import AppLink from "./AppLink"

export default {
  components: { AppLink },
  props: {
    link: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.text-link {
  display: inline-flex;
  align-items: center;

  &__content {
    text-decoration: underline;
    font-size: $font-size-4;
  }

  &__icon {
    display: inline-block;
    margin-right: $spacing-2;
    font-weight: $weight-bold;

    &::before {
      display: inline-block;
    }
  }
}
</style>
